// extracted by mini-css-extract-plugin
module.exports = {"place":"Place_place__v2qCc","container":"Place_container__rdiZJ","place__images":"Place_place__images__lplbR","place__media":"Place_place__media__UPn7j"};